import uuid from "uuid/v1";

export default function generateUuid() {
  return uuid();
}
